import { parseCookies } from 'nookies';
import { StorageKey } from '../../common/CookiesProvider/CookiesProvider';
import { BookingSource, DisplayAppointment } from '../../common/schema/hannibal/types.generated';

export type BookingFormClient =
  | 'book'
  | 'book_mobile'
  | 'book_iphone'
  | 'book_android'
  | 'book_widget'
  | 'book_webplugin'
  | 'book_practice'
  | 'book_as_practice';

const mobileClients: BookingFormClient[] = ['book_mobile', 'book_iphone', 'book_android'];

export const bookingSourceForClient = (client: BookingFormClient): BookingSource =>
  mobileClients.includes(client) ? BookingSource.Mobile : BookingSource.Web;

export const useDisplayAppointment = (
  bookingFormClient?: BookingFormClient,
): DisplayAppointment => {
  switch (bookingFormClient) {
    case 'book_as_practice':
      return DisplayAppointment.All;
    case 'book_widget':
    case 'book_webplugin':
    case 'book_practice':
      return DisplayAppointment.Platform;
    case 'book_mobile':
    case 'book_iphone':
    case 'book_android':
      return displayForSearchMedium(searchMediumFromCookie());
    default:
      return DisplayAppointment.Network;
  }
};

const displayForSearchMedium = (searchMedium: number | undefined): DisplayAppointment => {
  switch (searchMedium) {
    case 1:
      return DisplayAppointment.Network;
    case 2:
      return DisplayAppointment.Platform;
    case 3:
      return DisplayAppointment.All;
    default:
      return DisplayAppointment.Network;
  }
};

const searchMediumFromCookie = (): number | undefined => {
  const cookies = parseCookies();

  if (cookies === null) return undefined;

  const cookieValue = Number(cookies[StorageKey.SEARCH_MEDIUM]);

  return isNaN(cookieValue) ? undefined : cookieValue;
};
